import React from 'react';

export const SirenIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="19" viewBox="0 0 24 22.501">
  <g id="megaphone-1" transform="translate(0 -0.749)">
    <path id="Path_9048" data-name="Path 9048" d="M24,1.749a1,1,0,1,0-2,0v.774L3.846,8.384A.5.5,0,0,0,3.5,8.86v5.957a.5.5,0,0,0,.35.477l1.3.408a.5.5,0,0,1,.35.477V18.77A4.505,4.505,0,0,0,10,23.25h.021A4.5,4.5,0,0,0,14.5,18.733v-.1l7.5,2.35v.766a1,1,0,0,0,2,0ZM12.5,18.738a2.5,2.5,0,0,1-2.488,2.512H10a2.5,2.5,0,0,1-2.5-2.484V17.119a.5.5,0,0,1,.65-.477l4,1.254a.5.5,0,0,1,.35.477Z"/>
    <path id="Path_9049" data-name="Path 9049" d="M2,8.249a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1l0,7a1,1,0,0,0,1,1H1a1,1,0,0,0,1-.976Z"/>
  </g>
</svg>
);